import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import qs from 'qs';
import VenueSliderSkeleton from '../../components/VenueSliderSkeleton/VenueSliderSkeleton';
import * as constants from '../../util/constants';
import helpers from '../../util/helpers';

class AppHotelVenues extends Component {
  constructor(props) {
    super(props);

    // Initial state
    this.initialState = {
      loading: true,
      allVenues: [],
      layout: 'grid',
    };

    // Assign first state
    this.state = Object.assign({}, this.initialState);

    this.postID = '';
    this.pageType = '';
    this.heading = 'Venues';
    this.defaultView = 'grid';

    const venuesWrapper = $('#hotel-venues-wrapper');
    if (venuesWrapper.length) {
      this.postID = venuesWrapper.data('post-id');
      this.pageType = venuesWrapper.data('page-type');
      this.heading = venuesWrapper.data('heading');
      this.defaultView = venuesWrapper.data('default-view');
    }

    // Bind "this"
    this.loadHotelVenues = this.loadHotelVenues.bind(this);
    this.changeLayout = this.changeLayout.bind(this);
  }

  loadHotelVenues() {
    // Reset state
    this.setState(this.initialState);

    const data = {
      'action': constants.ACTION_GET_HOTEL_VENUES,
      'postID': this.postID,
      'pageType': this.pageType,
    };

    // Send request
    axios.post(window.Rydges['ajaxUrl'], qs.stringify(data)).then((axiosResponse) => {
      if (200 === axiosResponse.status) {
        const response = axiosResponse.data;

        if (response.success) {
          this.setState({
            loading: false,
            allVenues: response.data['venues'],
          });
        } else {
          this.setState({
            loading: false,
            allVenues: [],
          });
        }
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  changeLayout(e, layout) {
    e.preventDefault();

    this.setState({layout: layout});
  }

  componentDidMount() {
    // Load venues on first page load
    this.loadHotelVenues();

    if (this.defaultView.length > 0) {
      this.setState({layout: this.defaultView});
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (prevState.loading && !this.state.loading) ||
      (prevState.layout === 'table' && this.state.layout === 'grid')
    ) {
      // Equal height for elements
      $(document).trigger(constants.EVENT_BALANCE_ELEMENTS);
    }
  }

  render() {
    const {
      pageType,
      heading,
    } = this;
    const {
      loading,
      allVenues,
      layout,
    } = this.state;

    return (
      <React.Fragment>
        <div className="container">
          <h2 className="mb-3 mb-lg-4">
            <div className="d-inline-block">
              <div className="d-flex align-items-center">
                {
                  heading.length > 0 && (
                    <span className="mr-3">{heading}</span>
                  )
                }
                {
                  !loading && (
                    <div className="view-layout-buttons">
                      <a href="#" className={'mr-2 ' + (layout === 'grid' ? 'text-red' : '')} onClick={(e) => {this.changeLayout(e, 'grid');}}>
                        View Images
                      </a>
                      |
                      <a href="#" className={'ml-2 ' + (layout === 'table' ? 'text-red' : '')} onClick={(e) => {this.changeLayout(e, 'table');}}>
                        View Capacities
                      </a>
                    </div>
                  )
                }
              </div>
            </div>
            {
              layout === 'grid' && (
                <span className="arrows d-none d-lg-block float-right">
                  <button type="button" data-role="none" className="prev" aria-label="Prev" tabIndex="0" role="button">
                    <img className="img-fluid" src={window.Rydges['assetsPath'] + 'images/icons/left-chevron-black.svg'} alt="Prev" />
                  </button>

                  <button type="button" data-role="none" className="next" aria-label="Next" tabIndex="1" role="button">
                    <img className="img-fluid" src={window.Rydges['assetsPath'] + 'images/icons/right-chevron-black.svg'} alt="Next" />
                  </button>
                </span>
              )
            }
          </h2>
          {
            !loading && allVenues.length > 0 && (
              <React.Fragment>
                {
                  layout === 'grid' && (
                    <div className="slider px-2 px-lg-0">
                      {
                        allVenues.map((venue, i) => {
                          return (
                            <div className="slide px-3" key={i}>
                              <a className="slide-wrapper d-block" href={venue['link']}>
                                <div className="slide-image-wrapper">
                                  <div className="featured-image bg-center position-relative" style={{backgroundImage: `url(${venue['image']})`}} />
                                </div>
                              </a>
                              <div className="inner-content equal-height p-3 p-lg-4">
                                {
                                  venue['name'].length > 0 && (
                                    <h3 className="h2">
                                      <a className="slide-wrapper d-block" href={venue['link']}>
                                        {venue['name']}
                                      </a>
                                    </h3>
                                  )
                                }
                                {
                                  venue['content'].length > 0 && (
                                    <p dangerouslySetInnerHTML={{__html: venue['content']}}/>
                                  )
                                }
                                {
                                  (venue['area'].length > 0 || venue['ceiling_height'].length > 0 || venue['max_capacity']) && (
                                    <React.Fragment>
                                      <div className="venue-details-collapse-btn d-flex align-items-center mb-2 text-red collapsed" data-toggle="collapse" data-target=".venue-details-collapse" aria-expanded="false" aria-controls="venue-details-collapse">
                                        <span className="mr-2">Show specs</span>
                                        <img className="img-fluid arrow-icon" src={window.Rydges['assetsPath'] + 'images/icons/down-chevron.svg'} />
                                      </div>
                                      <div className="venue-details-collapse collapse">
                                        {
                                          venue['area'].length > 0 && (
                                            <div className="mb-2">
                                              <span className="font-weight-bold mr-2">Area:</span>{venue['area']}&nbsp;m<sup>2</sup>
                                            </div>
                                          )
                                        }
                                        {
                                          venue['ceiling_height'].length > 0 && (
                                            <div className="mb-2">
                                              <span className="font-weight-bold mr-2">Ceiling Height:</span>{venue['ceiling_height']}&nbsp;m
                                            </div>
                                          )
                                        }
                                        {
                                          venue['max_capacity'].length > 0 && (
                                            <div className="mb-2">
                                              <span className="font-weight-bold mr-2">Max Capacity:</span>{venue['max_capacity']}
                                            </div>
                                          )
                                        }
                                      </div>
                                    </React.Fragment>
                                  )
                                }
                              </div>
                            </div>
                          );
                        })
                      }
                    </div>
                  )
                }
                {
                  layout === 'table' && (
                    <div className="table-responsive">
                      <table className="table table-brand">
                        <thead>
                          <tr className="text-uppercase">
                            <th>Room/space</th>
                            <th>Area</th>
                            <th>Ceiling height</th>
                            <th>Capacity</th>
                            <th>Banquet capacity</th>
                            <th>Cocktail capacity</th>
                            <th>Cabaret capacity</th>
                            <th>Classroom capacity</th>
                            {
                              pageType !== 'weddings' && (
                                <React.Fragment>
                                  <th>Boardroom capacity</th>
                                  <th>Theatre capacity</th>
                                  <th>U-shape capacity</th>
                                </React.Fragment>
                              )
                            }
                          </tr>
                        </thead>
                        <tbody>
                          {
                            allVenues.map((venue, i) => {
                              return (
                                <tr key={i}>
                                  <td>
                                    {
                                      venue['name'].length > 0 && (
                                        <a href={venue['link']}>
                                          {venue['name']}
                                        </a>
                                      )
                                    }
                                  </td>
                                  <td>
                                    {
                                      venue['area'].length > 0
                                        ? <span>{venue['area']}&nbsp;m<sup>2</sup></span>
                                        : 'N/A'
                                    }
                                  </td>
                                  <td>
                                    {
                                      venue['ceiling_height'].length > 0
                                        ? <span>{venue['ceiling_height']}&nbsp;m</span>
                                        : 'N/A'
                                    }
                                  </td>
                                  <td>
                                    {
                                      venue['max_capacity'].length > 0
                                        ? <span>{venue['max_capacity']}</span>
                                        : 'N/A'
                                    }
                                  </td>
                                  <td>
                                    {
                                      venue['banquet_capacity'].length > 0
                                        ? <span>{venue['banquet_capacity']}</span>
                                        : 'N/A'
                                    }
                                  </td>
                                  <td>
                                    {
                                      venue['cocktail_capacity'].length > 0
                                        ? <span>{venue['cocktail_capacity']}</span>
                                        : 'N/A'
                                    }
                                  </td>
                                  <td>
                                    {
                                      venue['cabaret_capacity'].length > 0
                                        ? <span>{venue['cabaret_capacity']}</span>
                                        : 'N/A'
                                    }
                                  </td>
                                  <td>
                                    {
                                      venue['classroom_capacity'].length > 0
                                        ? <span>{venue['classroom_capacity']}</span>
                                        : 'N/A'
                                    }
                                  </td>
                                  {
                                    pageType !== 'weddings' && (
                                      <React.Fragment>
                                        <td>
                                          {
                                            venue['boardroom_capacity'].length > 0
                                              ? <span>{venue['boardroom_capacity']}</span>
                                              : 'N/A'
                                          }
                                        </td>
                                        <td>
                                          {
                                            venue['theatre_capacity'].length > 0
                                              ? <span>{venue['theatre_capacity']}</span>
                                              : 'N/A'
                                          }
                                        </td>
                                        <td>
                                          {
                                            venue['u_shape_capacity'].length > 0
                                              ? <span>{venue['u_shape_capacity']}</span>
                                              : 'N/A'
                                          }
                                        </td>
                                      </React.Fragment>
                                    )
                                  }
                                </tr>
                              );
                            })
                          }
                        </tbody>
                      </table>
                    </div>
                  )
                }
              </React.Fragment>
            )
          }
          {
            loading && (
              <VenueSliderSkeleton />
            )
          }
        </div>
      </React.Fragment>
    );
  }
}

const venuesSliderTable = () => {
  jQuery(document).ready(function($) {
    const venuesWrapper = $('#hotel-venues-wrapper');
    if (venuesWrapper.length) {
      ReactDOM.render(<AppHotelVenues />, venuesWrapper[0]);
    }

    // Trigger slick on results loaded
    const loadVenueSlider = () => {
      const slider = $('.section-hotel-venue-slider .slider');
      if (slider.length) {
        if (!slider.hasClass('slick-initialized')) {
          slider.on('init', function() {
            helpers.equalHeightElements('.slider .equal-height');
          });

          slider.slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 1,
            mobileFirst: true,
            prevArrow: $('.section-hotel-venue-slider .prev'),
            nextArrow: $('.section-hotel-venue-slider .next'),
            responsive: [
              {
                breakpoint: 991,
                settings: {
                  slidesToShow: 2,
                },
              },
            ],
          });
        }
      }
    };

    $(document).on(constants.EVENT_BALANCE_ELEMENTS, loadVenueSlider);
  });
};

export default venuesSliderTable;



// WEBPACK FOOTER //
// ./scripts/routes/modules/venuesSliderTable.js